export default "__VITE_ASSET__37e4327e__"